import { orchestrator } from 'satcheljs';
import { isFeatureEnabled } from 'owa-feature-flags';
import { applyOptions } from '../actions/activityFeedApplyOptions';
import {
    loadMentionEventNotificationsOptions,
    loadTxpEventNotificationsOptions,
} from '../service/loadActivityFeedOptions';
import {
    createOrUpdateMentionEventNotificationsOptions,
    createOrUpdateTxpEventNotificationsOptions,
} from '../service/saveActivityFeedOptions';

async function toggleMentionsProcessor() {
    const userOptions = await loadMentionEventNotificationsOptions();

    const featureEnabled: boolean = isFeatureEnabled('auth-activityFeedAtMentionsProcessor');
    if (featureEnabled && !userOptions.enabled) {
        userOptions.enabled = true;
        createOrUpdateMentionEventNotificationsOptions(userOptions);
    } else if (!featureEnabled && userOptions.enabled) {
        userOptions.enabled = false;
        createOrUpdateMentionEventNotificationsOptions(userOptions);
    }
}

async function toggleTxpProcessor() {
    const userOptions = await loadTxpEventNotificationsOptions();

    const featureEnabled: boolean = isFeatureEnabled('auth-activityFeedTxpProcessor');
    if (featureEnabled && !userOptions.enabled) {
        userOptions.enabled = true;
        createOrUpdateTxpEventNotificationsOptions(userOptions);
    } else if (!featureEnabled && userOptions.enabled) {
        userOptions.enabled = false;
        createOrUpdateTxpEventNotificationsOptions(userOptions);
    }
}

// Refreshing the app or closing/opening the panel toggles the options
// server side based on related feature flags.
orchestrator(applyOptions, () => {
    toggleMentionsProcessor();
    toggleTxpProcessor();
});
